import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CreditCardPaymentService,
  ICreditPayReq,
} from 'src/app/public-website/buyer/services/creditCardPayment.service';
import { ViewProductInfoHandlerService } from 'src/app/public-website/buyer/services/view-product-info-handler.service';
import { Validators } from '../../../../../../shared/validators';
import { CustomValidators } from '../../../../../../shared/custom-validators';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CancelCreditPaymentService } from '../../../../services/cancel-credit-payment.service';
import { PAYMENTATTEMPT_STATUS } from 'src/app/shared/paymentStatuses';
import { TranslateService } from '@ngx-translate/core';
import { CreditCardPay } from 'src/app/public-website/buyer/services/creditCardPay.service';
import { GetIpService } from 'src/app/public-website/buyer/services/get-ip-address.service';
import { loadStripe } from '@stripe/stripe-js';

@Component({
  selector: 'app-credit-card-pay',
  templateUrl: './credit-card-pay.component.html',
  styleUrls: ['./credit-card-pay.component.scss'],
})
export class CreditCardPayComponent implements OnInit {
  formValidator = new FormValidatorService();
  selectedInstallmentPlan: string
  installmentPlans: string[]
  creditCardForm!: FormGroup;
  interval:any; // unable to determine its type
  isInstallments: boolean = false;
  cardErrors:string = '';

  installmentPlansMapping = {
    "6 Months - NBE": "6",
    "12 Months - NBE": "12",
    "18 Months - NBE": "18",
    "6 Months - BM": "6",
    "12 Months - BM": "12",
    "18 Months - BM": "18",
  }

  creditCardFields = {
    creditCardNumber: {
      fieldName: 'Number',
      fieldType: 'tel',
      autoCompleteName:'cc-number',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: Validators.minLength(16),
          message: '',
        },
        {
          validatorFn: Validators.maxLength(19),
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9\s]*$/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    expirationMonthAndYear: {
      fieldName: 'expiration',
      fieldType: 'tel',
      autoCompleteName:'cc-exp',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/(\d\d)\s*\/\s*(\d\d)/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    securityCode: {
      fieldName: 'CVV',
      fieldType: 'tel',
      autoCompleteName:'cc-csc',
      validators: [
        {
          validatorFn: Validators.required,
          message: '',
        },
        {
          validatorFn: Validators.maxLength(4),
          message: '',
        },
        {
          validatorFn: Validators.minLength(3),
          message: '',
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9*\s]*$/),
          message: '',
        },
      ],
      defaultValue: '',
    },
    cardType: {
      fieldName: 'cardType',
      defaultValue: '',
    },
  };
  openOtp: boolean = false;
  otpReqObj: IDirectPayResponse;
  authenticateObj: IDirectAuthenticateResponse;
  submitted = false;

  constructor(
    public vpihs: ViewProductInfoHandlerService,
    public creditCardService: CreditCardPaymentService,
    public creditCardPay : CreditCardPay,
    private getIpService : GetIpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cancelCreditPaymentService: CancelCreditPaymentService,
    private translate: TranslateService,
  ) {
    if (
      !this.vpihs.productId &&
      !this.vpihs.paymentOptionObject.selection &&
      !this.vpihs.viewInfoObject &&
      !this.creditCardService.providerObject
    ) {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }
  }

  async ngOnInit(): Promise<void> {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.creditCardForm = this.formValidator.createForm(
      Object.values(this.creditCardFields)
    );
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
	if (
      this.vpihs.paymentOptionObject.selection.includes('NBE') ||
      this.vpihs.paymentOptionObject.selection.includes('BM')
    ) {
      this.isInstallments = true;
      this.selectedInstallmentPlan = this.vpihs.paymentOptionObject.selection;
    }
    this.setLocalStorageItems()
    await this.makePageExpired();
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        creditCardNumber: {
          required: this.translate.instant('FormValidation.Empty', {
            field: "Credit card number",
            fieldAr: "رقم بطاقه الائتمان"
          }),
          customPattern: this.translate.instant('FormValidation.RequiredNumber', {
            field: "Credit card number",
            fieldAr: "رقم بطاقه الائتمان"
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: "Credit card number",
            fieldAr: "رقم بطاقه الائتمان",
            value: 16
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: "Credit card number",
            fieldAr: "رقم بطاقه الائتمان",
            value: 19
          }),
        },
        expirationMonthAndYear: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Expiration',
            fieldAr: 'انتهاء الصلاحية'
          }),
          customPattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Expiration',
            fieldAr: 'انتهاء الصلاحية'
          }),
        },
        securityCode: {
          required: this.translate.instant('FormValidation.Empty', {
            field: "CVV",
            fieldAr: "CVV"
          }),
          customPattern: this.translate.instant('FormValidation.RequiredNumber', {
            field: "CVV",
            fieldAr: "CVV"
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: "CVV",
            fieldAr: "CVV",
            value: 3
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: "CVV",
            fieldAr: "CVV",
            value: 4
          }),
        },
      }
    });
  }

  /**
   * this is the start of the form handling format and submit
   */

  convertPaymentControl(name: string): FormControl {
    return this.creditCardForm.controls[name] as FormControl;
  }
  async submit(): Promise<void> {
    await this.initStep();
    await this.authenticateStep();
    if(this.authenticateObj.success) await this.payStep();
  }

  //cancel credit card payment
  async cancelPayment(status: string): Promise<void> {
    try {
      this.cancelCreditPaymentService.setParams({
        refNum: this.creditCardService.trxRefNum,
        status,
        merchant_ref_num: this.creditCardService.merchant_ref_num,
      });
      await this.cancelCreditPaymentService.make();
    } catch (error) {
      console.log('cancel payment error: ', error);
    }
  }

  //expire the page after one hour
  async makePageExpired(): Promise<void> {
    await this.sleep(1000 * 60 * 60);
    await this.onCallBack(PAYMENTATTEMPT_STATUS.EXPIRED);
  }
  async sleep(ms: any): Promise<Function> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  //onCallBack
  async onCallBack(response: string): Promise<void> {
    switch (response) {
      case PAYMENTATTEMPT_STATUS.CANCELED:
        await this.cancelPayment(response);
        this.handleCloseOrExpire(response);
        break;
      case PAYMENTATTEMPT_STATUS.PAID:
        this.handleCloseOrExpire(response);
        break;
      case PAYMENTATTEMPT_STATUS.EXPIRED:
        await this.cancelPayment(response);
        this.handleCloseOrExpire(response);
        break;
      case PAYMENTATTEMPT_STATUS.FAILED:
        this.onErrorCallback(response);
        break;
      default:
        this.handleCloseOrExpire('Unknown');
    }
  }
  //handlecall back
  handleCloseOrExpire(reason: string): void {
    this.router.navigate(['gate'], {
      queryParams: {
        refNum: this.creditCardService.trxRefNum,
        reason: reason,
      },
    });
  }
  onErrorCallback(reason: string): void {
    this.router.navigate(['gate'], {
      queryParams: {
        refNum: this.creditCardService.trxRefNum,
        reason: reason,
        card: 1
      },
    });
  }

  setLocalStorageItems(): void{
    localStorage.setItem('vpihs', JSON.stringify(this.vpihs.getSubmitObject()));
    localStorage.setItem(
      'code',
      JSON.stringify(this.vpihs.viewInfoObject.product.code)
    );
    localStorage.setItem(
      'viewInfoObject',
      JSON.stringify(this.vpihs.viewInfoObject)
    );
  }

  calculateMonthlyInstallmentAmount(): string{
    let numberOfMonths: number = +this.installmentPlansMapping[this.selectedInstallmentPlan]
    let amount: number = this.creditCardService.providerObject.amount
    if (this.translate.currentLang == 'en') {
      return (amount / numberOfMonths).toFixed(2) + '/month';
    } else {
      return (amount / numberOfMonths).toFixed(2) + '/شهر';
    }
  }

  creditCardBoxHeader(): string {
    if (document.body.classList.contains('dir-rtl')) {
      if (this.isInstallments) {
        return `املأ تفاصيل بطاقتك الائتمانيه لبدء ${this.installmentPlansMapping[this.selectedInstallmentPlan]} شهر أقساط ${this.calculateMonthlyInstallmentAmount()}`
      } else {
        return `املأ معلومات بطاقتك الائتمانية للدفع
        ${(this.vpihs.total + this.vpihs.donation).toFixed(2)} ${this.vpihs.currency}`
      }
    } else {
      if (this.isInstallments) {
        return `Fill your credit card info to begin ${this.installmentPlansMapping[this.selectedInstallmentPlan]} months installments plan ${this.calculateMonthlyInstallmentAmount()}`
      } else {
        return `Fill your credit card info to pay
        ${(this.vpihs.total + this.vpihs.donation).toFixed(2)} ${this.vpihs.currency}`
      }
    }
  }
  async providerInfoGathering(){
    document.getElementById('providerExtraInfoGathering').innerHTML = this.authenticateObj.html;
    eval(document.getElementById('initiate-authentication-script')?.innerText)
  }
  showOtp(){
    this.creditCardService.otpPage = this.otpReqObj.html;
    this.openOtp = true;
  }

  async initStep() {
    const payObject: ICreditPayReq = {
      number: this.creditCardForm.controls['Number'].value,
      'security-code': this.creditCardForm.controls['CVV'].value,
      'expiration-month-and-year':
        this.creditCardForm.controls['expiration'].value,
      providerType: this.creditCardForm.controls['cardType'].value,
      trxRef: this.creditCardService.providerObject.trxRefNum,
      operationType: 'credit_card',
      publicToken: '',
    };
    this.creditCardService.setPayToken(payObject);
    this.authenticateObj = await this.creditCardService.make();
    if(!this.authenticateObj?.success){
      this.cardErrors =
      this.authenticateObj.message == 'InvalidCardNumber'
      ? 'Buyer.InvalidCardNumber'
      : this.authenticateObj.message == 'This business does not have the privilege for international transactions.'
      ? 'Buyer.InternationalPrivilegeError'
      : 'Buyer.authenticationIssue';

        this.creditCardForm.setErrors(null);
        return;
    }
    this.authenticateObj.orderData.browser = window.navigator.userAgent;
    let ip = null;
    try{
      ip = (await this.getIpService.make()).ip
    }catch(e){
      console.log(e);
    }
    this.authenticateObj.orderData.ipAddress = ip;
  }

  async authenticateStep() {
    if (this.authenticateObj.success) {
      const params = {
        ...this.authenticateObj.orderData,
        token: this.creditCardService.encToken,
        payment_method_id: undefined,
        payment_intent_id: undefined,
        trxRef: this.creditCardService.providerObject.trxRefNum,
      };

      if (this.authenticateObj.payment_method_id) {
        params.payment_method_id = this.authenticateObj.payment_method_id;
      }

      await this.providerInfoGathering();
      this.creditCardPay.setParams(params);
      this.otpReqObj = await this.creditCardPay.make();

      if (this.otpReqObj.requires_action) {
        const stripe = await loadStripe(
          this.authenticateObj.stripe_publishable_key,
        );
        const { error, paymentIntent } = await stripe.handleCardAction(
          this.otpReqObj.payment_intent_client_secret,
        );

        if (paymentIntent) {
          params.payment_intent_id = paymentIntent.id;
        } else {
          params.payment_intent_id = error.payment_intent?.id;
        }

        params.payment_method_id = undefined;
        this.creditCardPay.setParams(params);
        this.otpReqObj = await this.creditCardPay.make();
      }
    }
  }

  async payStep() {
    if (this.otpReqObj.redirectUrl && this.otpReqObj.success) {
      //rendersuccess
      this.showOtp();
    } else if (this.otpReqObj.message && !this.otpReqObj.success) {
      //card issues
      if (this.otpReqObj.message == 'cardInvalid') {
        this.cardErrors = 'Buyer.CardInvalid';
      } else if (this.otpReqObj.message == 'providerError') {
        this.cardErrors = 'Buyer.ProviderError';
      } else if (this.otpReqObj.message == 'fraudDetected') {
        this.cardErrors = 'Buyer.fraudDetected';
      } else if (this.otpReqObj.message == 'transactionDuplicate') {
        this.cardErrors = 'Buyer.transactionDuplicate';
      } else {
        this.cardErrors = 'Buyer.UnknownCardError';
      }
    } else if (this.otpReqObj.success && !this.otpReqObj.redirectUrl) {
      //none render successulcase
      await this.onCallBack(PAYMENTATTEMPT_STATUS.PAID);
    } else if (!this.otpReqObj.success) {
      //none render failed case
      await this.onCallBack(PAYMENTATTEMPT_STATUS.FAILED);
    }
  }
}

interface IDirectPayResponse{
  redirectUrl: string;
  html?:string;
  submitUrl?:string;
  message?:string;
  success: boolean;
  requires_action?: boolean;
  payment_intent_client_secret?: string;
}
interface IDirectAuthenticateResponse{
  message: string;
  html:string,
  orderData:{
    orderId:string,
    trxRef:string,
    browser?:string,
    ipAddress?:string,
  }
  success:boolean;
  payment_method_id?: string;
  stripe_publishable_key?: string;
}
